import React, { useEffect, useState } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { filter } from 'rxjs/operators';

import PackagePlansOptions from '../../components/payment/PackagePlansOptions';
import PackagePlansPricingContainer from '../../components/payment/PackagePlansPricingContainer';
import PackagePlansVideo from '../../components/payment/PackagePlansVideo';
import PaymentFaq from '../../components/payment/PaymentFaq';
import PlainOverlay from '../../components/plainOverlay/PlainOverlay';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('paymentBloc');
  const history = useHistory();
  const location = useLocation();
  const [description, setDescription] = useState('After you purchase a package, you can upload your study to have a video report made.');
  const [packageOption, setPackageOption] = useState('video');
  const [userDetails, setUserDetails] = useState(null);
  const [shouldOpenDashboard, setShouldOpenDashboard] = useState(null);
  const [shouldOpenRequestVideoReport, setShouldOpenRequestVideoReport] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [discountData, setDiscountData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePackageOption = (option) => {
    blocRef.current.handleChangePackageOption(option);
  };
  const handleCreateCaseCheckoutSession = (plan) => {
    if (plan === 'demo') {
      blocRef.current.changeToDemoUserState();
      return;
    }
    blocRef.current.createCaseCheckoutSession(plan);
  };
  const handleChatClick = () => {
    blocRef.current.openFreshchatDialog();
  };

  useEffect(() => {
    const userDetailsSub = blocRef.current.userDetails$.subscribe(setUserDetails);
    const downgradeSub = blocRef.current.planToDowngrade$.pipe(filter((e) => e)).subscribe(() => history.push('/downgrade'));
    const packageOptionSub = blocRef.current.packageOption$.subscribe(setPackageOption);
    const shouldOpenDashboardSub = blocRef.current.shouldOpenDashboard$.subscribe(setShouldOpenDashboard);
    const shouldOpenRequestVideoReportSub = blocRef.current.shouldOpenRequestVideoReport$.subscribe(setShouldOpenRequestVideoReport);
    const selectedRecordSub = blocRef.current.selectedRecord$.subscribe(setSelectedRecord);
    const isLoadingSub = blocRef.current.isLoading$.subscribe(setIsLoading);
    const discountDataSub = blocRef.current.couponData$.subscribe(setDiscountData);
    blocRef.current.handleGetWorkspaceDiscountDetail();

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();

      discountDataSub.unsubscribe();
      userDetailsSub.unsubscribe();
      downgradeSub.unsubscribe();
      packageOptionSub.unsubscribe();
      shouldOpenDashboardSub.unsubscribe();
      shouldOpenRequestVideoReportSub.unsubscribe();
      selectedRecordSub.unsubscribe();
      isLoadingSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const studyId = new URLSearchParams(location.search).get('studyId');
    if (studyId) blocRef.current.getCurrentStudy(studyId);
    else blocRef.current.getNotPaidCase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (userDetails?.availableReport) {
      history.push('/personalized-video');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  useEffect(() => {
    if (shouldOpenDashboard) {
      history.push('/patient-dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldOpenDashboard]);

  useEffect(() => {
    if (shouldOpenRequestVideoReport) {
      history.push('/personalized-video');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldOpenRequestVideoReport]);

  useEffect(() => {
    if (selectedRecord?.id || userDetails?.workspace?.canRequestBeforePay) {
      setDescription('Once you have selected a package and made payment, one of our radiology imaging specialists will begin working on your personalized video report.');
    }
  }, [selectedRecord, userDetails]);

  return (
    <>
      <PlainOverlay show={isLoading} />
      <PackagePlansOptions onPackageOptionChange={handleChangePackageOption} packageOption={packageOption} />

      <PackagePlansPricingContainer description={description}>
        <PackagePlansVideo
          userDetails={userDetails}
          onChatClick={handleChatClick}
          onSelect={handleCreateCaseCheckoutSession}
          selectedRecord={selectedRecord}
          discountData={discountData}
        />
      </PackagePlansPricingContainer>

      <PaymentFaq userDetails={userDetails} />
    </>
  );
};
